<template>
  <v-card elevation="0" class="all-trade-tab rounded-0 mt-5" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-tabs v-model="tab" :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-tab class="ml-0"> All Clients </v-tab>
       
      <v-tab-item>
        <TradeMasterInvestorAccount></TradeMasterInvestorAccount>
      </v-tab-item>
      
    </v-tabs>
  </v-card>
</template>
<script>
import TradeMasterInvestorAccount from './TradeMasterInvestorAccountTab.vue';

export default {
  components: {
    TradeMasterInvestorAccount,
  },
};
</script>